import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Inject,
  NgZone,
  Component,
  OnDestroy,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ChangeDetectionStrategy,
} from '@angular/core';

import { secondsHumanize } from '@lib/common/helpers';

import { ISnPlayer } from '../../interfaces';

@Component({
  selector: 'sn-player-time-control',
  templateUrl: './player-time.control.html',
  styleUrls: ['./player-time.control.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'sn-player__time-control',
  },
})
export class SnPlayerTimeControl implements AfterViewInit, OnDestroy {
  @ViewChild('currentTime')
  private readonly _currentTimeRef: ElementRef<HTMLElement>;

  @ViewChild('totalTime')
  private readonly _totalTimeRef: ElementRef<HTMLElement>;

  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _ngZone: NgZone,
    @Inject('SN_PLAYER') private readonly _player: ISnPlayer,
  ) {}

  public ngAfterViewInit(): void {
    this._ngZone.runOutsideAngular(() => {
      this._initSubscription();
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private _initSubscription(): void {
    this._player.currentTime$.pipe(takeUntil(this._destroy$)).subscribe((time) => {
      this._currentTimeRef.nativeElement.innerText = secondsHumanize(time);
    });

    this._player.totalTime$.pipe(takeUntil(this._destroy$)).subscribe((time) => {
      this._totalTimeRef.nativeElement.innerText = secondsHumanize(time);
    });
  }
}
